@let formValues = giftCardForm.value;

<div class="container">
  <div class="content">
    <div class="content__preview">
      <app-gift-card-preview
        [recipientName]="formValues['recipientName']"
        [senderName]="formValues['senderName']"
        [message]="formValues['senderMessage']"
        [amount]="formValues['amount']"
        [image]="formValues['image']"
      />
    </div>

    <div class="content__card">
      <h2 class="content__card-title">Buy Gift Card</h2>

      <form [formGroup]="giftCardForm" class="content__card-form form">
        <div class="form__group form__group--design">
          <div class="form__group-general group-general">
            <div class="group-general__content">
              <i class="icon icon-brush-sparkle-outline"></i>
              <h4 class="group-general__content-name">Design</h4>
            </div>
          </div>

          <div class="form__group-controls group-controls">
            <div class="group-controls__content">
              <app-gallery [(files)]="galleryFiles" formControlName="image" />
            </div>
          </div>
        </div>

        <div class="form__group form__group--recipient">
          <div class="form__group-general group-general">
            <div class="group-general__content">
              <i class="icon icon-user-sparkle-outline"></i>
              <h4 class="group-general__content-name">Recipient Info</h4>
            </div>
          </div>

          <div class="form__group-controls group-controls">
            <div class="group-controls__item">
              <app-input
                formControlName="recipientName"
                label="Name"
                placeholder="Enter Recipient Name"
                [style]="InputStyle.Secondary"
              />
            </div>

            <div class="group-controls__item">
              <app-input
                formControlName="recipientEmail"
                label="Email"
                placeholder="Enter Recipient Email"
                [style]="InputStyle.Secondary"
              />
            </div>
          </div>
        </div>

        <div class="form__group form__group--sender">
          <div class="form__group-general group-general">
            <div class="group-general__content">
              <i class="icon icon-user-outline"></i>
              <h4 class="group-general__content-name">Your Info</h4>
            </div>
          </div>

          <div class="form__group-controls group-controls">
            <div class="group-controls__item">
              <app-input
                formControlName="senderName"
                label="Name"
                placeholder="Enter Your Name"
                [style]="InputStyle.Secondary"
              />
            </div>

            <div class="group-controls__item">
              <app-textarea
                formControlName="senderMessage"
                label="Message to Recepient"
                placeholder="Enter Message"
                [style]="TextareaStyle.Secondary"
              />
            </div>
          </div>
        </div>

        <div class="form__group form__group--amount">
          <div class="form__group-general group-general">
            <div class="group-general__content">
              <i class="icon icon-sack-money-outline"></i>
              <h4 class="group-general__content-name">Select Amount</h4>
            </div>
          </div>

          <div class="form__group-controls group-controls">
            <div class="group-controls__item">
              <app-amount-selector
                formControlName="amount"
                [options]="AMOUNT_OPTIONS"
              />
            </div>
          </div>
        </div>

        <div class="form__footer">
          <div class="form__footer-counter">
            <app-counter [style]="CounterStyle.Primary" [min]="1" />
          </div>

          <div class="form__footer-submit submit">
            <app-button (buttonClick)="onSubmit()">
              <div class="submit__button">
                <span class="submit__button-label">Proceed to Checkout</span>
                <span class="submit__button-price">
                  {{
                    formValues['amount'] || 0 | currency: 'USD' : '$' : '1.0-2'
                  }}
                </span>
              </div>
            </app-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
